import CTAButton from "components/CTAButton";

const TechStack = () => {
    const techStackLogos = [
        {
            alt: "langchain",
            img: require("assets/images/tech-stack/langchain.png"),
        },
        {
            alt: "mistral",
            img: require("assets/images/tech-stack/mistral.png"),
        },
        {
            alt: "pinecone",
            img: require("assets/images/tech-stack/pinecone.png"),
        },
        {
            alt: "meta",
            img: require("assets/images/tech-stack/meta.png"),
        },
        {
            alt: "huggingface",
            img: require("assets/images/tech-stack/huggingface.png"),
        },
        {
            alt: "weightsandbiases",
            img: require("assets/images/tech-stack/weightsandbiases.png"),
        },
        {
            alt: "tableu",
            img: require("assets/images/tech-stack/tableau.png"),
        },
        {
            alt: "cube",
            img: require("assets/images/tech-stack/cube.png"),
        },
        {
            alt: "mosaic",
            img: require("assets/images/tech-stack/mosaic.png"),
        },
        {
            alt: "coursera",
            img: require("assets/images/tech-stack/netsuite.png"),
        },
        {
            alt: "workday",
            img: require("assets/images/tech-stack/workday.png"),
        },
        {
            alt: "adp",
            img: require("assets/images/tech-stack/adp.png"),
        },
    ]
    return (
        <section className="flex flex-col my-10 lg:my-20 gap-8 text-center text-black">
            <div className="text-6xl font-bold">
                Technology
            </div>
            <div className="leading-loose text-xl mb-3">
                Our comprehensive solutions ensure a seamless integration and smooth data <br /> transformation for your company:
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 flex-wrap gap-2 justify-center items-center max-w-[1420px] mx-auto">
                {
                    techStackLogos.map((logo, index) => (
                        <div key={logo.alt + index} className="border border-gray-300 px-4 lg:px-7 h-24 lg:h-36 w-full lg:w-[230px]  flex justify-center items-center rounded-xl hover:scale-125 transition-all ease-in-out duration-200 bg-white">
                            <img src={logo.img} alt={logo.alt} className="object-contain" width={"100%"} height={"100%"} loading="lazy" />
                        </div>
                    ))
                }
            </div>
            <a
                href="/technology"
                className='mt-4 md:mt-10 text-lg text-center rounded-lg mx-auto flex flex-row gap-2 justify-evenly items-center cursor-pointer group w-fit'>
                <span className="mb-1 font-bold text-nowrap mr-4 text-xl">See More</span>
                <svg class="transform scale-x-100 hover:animate-scale-x group-hover:animate-scale-x" xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 29 16" fill="none">
                    <path d="M28.7071 8.70711C29.0976 8.31658 29.0976 7.68342 28.7071 7.29289L22.3431 0.928932C21.9526 0.538408 21.3195 0.538408 20.9289 0.928932C20.5384 1.31946 20.5384 1.95262 20.9289 2.34315L26.5858 8L20.9289 13.6569C20.5384 14.0474 20.5384 14.6805 20.9289 15.0711C21.3195 15.4616 21.9526 15.4616 22.3431 15.0711L28.7071 8.70711ZM0 9H28V7H0V9Z" fill="black" />
                </svg>
            </a>
        </section>
    );
}

export default TechStack;